import React, { createContext, useReducer, useContext } from 'react';
import { Currency, IAnimalHeavenContext } from './animalHeaven.types';
import { animalHeavenReducer } from './animalHeaven.reducer';
import { getLanguageFromNavigator } from '../utils';

export const initialState = {
  animalSizes: [],
  gifToShow: '',
  loading: {
    animalSizes: false,
    petTypes: false,
    petCharacteristics: false,
  },
  locationStack: [],
  petTypes: [],
  petCharacteristics: [],
  token: localStorage.getItem('animal_heaven_token') || '',
  user: {
    currency: 'USD' as Currency,
    email: '',
    firstName: '',
    hasAdoptionCenter: false,
    id: '',
    isAdmin: false,
    language: getLanguageFromNavigator(),
    lastName: '',
    phone: '',
    phoneCode: '',
  },
};

export const AnimalHeavenContext = createContext<{
  animalHeavenState: IAnimalHeavenContext;
  animalHeavenDispatch: React.Dispatch<any>;
}>({
  animalHeavenState: initialState,
  animalHeavenDispatch: () => null,
});

const AnimalHeavenProvider = ({ children }: { children: React.ReactNode | undefined }) => {
  const [animalHeavenState, animalHeavenDispatch] = useReducer(animalHeavenReducer, initialState);

  return (
    <AnimalHeavenContext.Provider value={{ animalHeavenState, animalHeavenDispatch }}>
      {children}
    </AnimalHeavenContext.Provider>
  );
};
function useAnimalHeaven() {
  const { animalHeavenState, animalHeavenDispatch } = useContext(AnimalHeavenContext);
  if (animalHeavenState === undefined) {
    throw new Error('animalHeavenState error');
  }
  if (animalHeavenDispatch === undefined) {
    throw new Error('animalHeavenDispatch error');
  }
  return { ...animalHeavenState, animalHeavenDispatch };
}

export { AnimalHeavenProvider, useAnimalHeaven };
